import React from "react";
// import logo from "../../../assets/CombinedLogo.svg"

const AdminLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="flex space-x-3">
        <div className="w-2 h-8 bg-blue-500 rounded animate-bounce delay-0"></div>
        <div className="w-2 h-8 bg-blue-500 rounded animate-bounce delay-150"></div>
        <div className="w-2 h-8 bg-blue-500 rounded animate-bounce delay-300"></div>
        {/* <div className="flex gap-2 justify-center items-center">
          <div
            className="w-40 flex justify-center bg-white align-middle items-center p-2 cursor-pointer "
          >
            <img
              src={logo}
              alt="Logo"
              className=" w-full cursor-pointer"
            />
          </div>
          <div className="w-10 h-10 border-8 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div> */}

      </div>


    </div>
  );
};

export default AdminLoader;
